import { Generic } from '../dictionary-service';
import { Result } from './ai';

export enum Type {
  CV = 'cv',
  HR_DOCUMENT = 'hr_document',
  IDENTITY_DOCUMENT = 'identity_document',
  HANDWRITTEN = 'handwritten',
  JOB_OFFER = 'job_offer',
  TECHNICAL_TASK = 'technical_task',
  CORPORATE_DOCUMENT = 'corporate_document',
  IMAGE = 'image',
  VOICE = 'voice',
  UNKNOWN = 'unknown',
  ERROR = 'error',
  OTHER = 'other',
}

export enum ProcessingStatus {
  NEW = 'new', // File is just uploaded and not processed yet
  NORMALIZED = 'normalized', // File is normalized and ready to be analyzed
  REJECTED = 'rejected', // File is rejected automatically
  REJECTED_CONFIRMED = 'rejected_confirmed', // Rejected file verified  and confirmed by user
  PARSED = 'parsed', // File is parsed and ready to be vectorized
  VECTORIZED = 'vectorized', // File is vectorized
  DUPLICATE = 'duplicate', // File is duplicate and will be processed
  ERROR = 'error', // File is error and not processed yet
  IGNORED = 'ignored', // File is ignored and will not be processed (e.g., stuff reserve CV)
}

export type StorageType = 'main-cv' | 'temporary-cv' | 'mail-attachments';

export interface UploadMetadata {
  readonly buffer: string;
  readonly filename: string;
  readonly mimeType: string;
  readonly fileType: Type;
  readonly storage: StorageType;
}

export interface UploadByUrlMetadata extends Omit<UploadMetadata, 'buffer'> {
  readonly url: string;
}

export interface CandidateFile {
  readonly id: number;
  readonly createdAt: Date;
  readonly path: string;
  readonly mimeType: string | null;
  readonly type: Type;
  readonly name: string;
}

export interface CreatePayload {
  readonly filename: string;
  readonly fileType: Type;
  readonly html: string;
}

export interface MovementPayload {
  readonly id: number;
  readonly profileId: number;
}

export interface ReviewResponse {
  readonly id: number;
  readonly createdAt: Date;
  readonly updatedAt: Date;
  readonly type: Type;
  readonly processingStatus: ProcessingStatus;
  readonly mimeType: string | null;
  readonly path: string;
  readonly normalizedPdfPath: string | null;
  readonly size: number;
  readonly addedBy: Generic.Item;
  readonly profile: Generic.Item | null;
}

export interface ProfileFileUpload extends UploadMetadata {
  readonly profileId: number;
}

export interface DeleteCvPayload {
  readonly profileId: number;
  readonly cvType: Type;
  readonly namePattern: string;
}

export interface UploadResponse {
  readonly id: number;
  readonly createdAt: string;
  readonly path: string;
  readonly mimeType: string;
  readonly type: Type;
  readonly aiParsingData: Result | null;
}

export interface StatisticQuery {
  readonly fileType: Type[];
  readonly fileStatus: ProcessingStatus[];
}

export interface StatisticResponse {
  readonly types: Record<Type, number>;
  readonly statuses: Record<ProcessingStatus, number>;
}
